// for popup
let grArtBtn = Array.from(document.querySelectorAll("#gr-btn-art"));
let grPopupOverlay = document.querySelector(".gr-popup-overlay");
let grPopupClose = document.querySelector(".gr-close-popup");
let grPopupContainer = document.querySelector(".gr-popup-conteiner");
let grPopupContent = document.querySelector(".gr-popup-content");
let grBody = document.body;

grArtBtn.forEach((btn) => {
  btn.addEventListener("click", function(el) {
    let parent = el.target.parentElement;
    let info = parent.querySelector(".artist-info__text").innerHTML;
    grPopupContent.innerHTML = info;

    grPopupOverlay.classList.add("active");
    grBody.classList.add("gr-no-scroll");
  });
})

grPopupClose.addEventListener("click", function(){
  grPopupOverlay.classList.remove("active");
  grBody.classList.remove("gr-no-scroll");
});

document.addEventListener('click', (e) => {
  if(e.target.classList.contains("gr-popup-overlay")) {
    e.preventDefault();
    e.stopPropagation();
    grPopupOverlay.classList.remove("active");
    grBody.classList.remove("gr-no-scroll");
  }
});
document.addEventListener('keyup', function (e) {
  if(e.code == 'Escape') {
    grPopupOverlay.classList.remove("active");
    grBody.classList.remove("gr-no-scroll");
  }

});